import { render, staticRenderFns } from "./il-shop-article-list.vue?vue&type=template&id=34649dfc&scoped=true"
import script from "./il-shop-article-list.vue?vue&type=script&lang=ts"
export * from "./il-shop-article-list.vue?vue&type=script&lang=ts"
import style0 from "./il-shop-article-list.vue?vue&type=style&index=0&id=34649dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34649dfc",
  null
  
)

export default component.exports